import { Form210 } from "../components/form210/Form210";

const Page = (props) => {
  return <Form210 {...props} />;
};

export default Page;
